// AddFaq.jsx
import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Navigate } from "react-router-dom";

import { Card, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";

export default class AddFaq extends Component {
  state = {
    question: "",
    answer: "",
    status: "active",
    is_delete: "no",

    message: "",
    notification: false,
    notiColor: "success",
    redirect: false,
    loading: false,
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { question, answer, status, is_delete } = this.state;

    if (!question) {
      this.setState({ notification: true, notiColor: "warning", message: "Question is required!" });
      setTimeout(() => this.setState({ notification: false, message: "" }), 2500);
      return;
    }

    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    const body = { question, answer, status, is_delete };
    this.setState({ loading: true });

    axios
      .post(Constants.postUrls.createFaq, body)
      .then((resp) => {
        this.setState({
          notification: true,
          notiColor: "success",
          message: resp.data?.message || "FAQ created successfully!",
          loading: false,
        });
        setTimeout(() => this.setState({ notification: false, message: "", redirect: true }), 1200);
      })
      .catch((err) => {
        this.setState({
          notification: true,
          notiColor: "warning",
          message: err?.response?.data?.message || "Failed to create FAQ",
          loading: false,
        });
        setTimeout(() => this.setState({ notification: false, message: "" }), 3000);
      });
  };

  render() {
    if (this.state.redirect) return <Navigate to="/faqs" />;

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Create FAQ
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item sm={12}>
                    <TextField
                      type="text"
                      label="Question"
                      name="question"
                      onChange={this.handleInput}
                      value={this.state.question}
                      style={{ width: "100%" }}
                    />
                  </Grid>

                  <Grid item sm={12}>
                    <TextField
                      type="text"
                      label="Answer (small)"
                      name="answer"
                      onChange={this.handleInput}
                      value={this.state.answer}
                      style={{ width: "100%" }}
                      multiline
                      rows={4}
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <InputLabel>Status</InputLabel>
                    <Select
                      value={this.state.status}
                      onChange={(e) => this.setState({ status: e.target.value })}
                      name="status"
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="inactive">Inactive</MenuItem>
                    </Select>
                  </Grid>

                  <Grid item sm={6}>
                    <InputLabel>Is Delete</InputLabel>
                    <Select
                      value={this.state.is_delete}
                      onChange={(e) => this.setState({ is_delete: e.target.value })}
                      name="is_delete"
                      style={{ width: "100%", height: "45px", color: "#111" }}
                    >
                      <MenuItem value="no">No</MenuItem>
                      <MenuItem value="yes">Yes</MenuItem>
                    </Select>
                  </Grid>

                  <Grid item sm={12}>
                    <MDButton variant="contained" size="small" color="info" type="submit">
                      {this.state.loading ? "Creating..." : "Create"}
                    </MDButton>
                  </Grid>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="FAQ Admin"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
